var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53 1.53C5.60368 1.46134 5.66279 1.37854 5.70378 1.28654C5.74477 1.19454 5.76681 1.09523 5.76859 0.994523C5.77036 0.893821 5.75184 0.793791 5.71412 0.700403C5.6764 0.607015 5.62025 0.522181 5.54903 0.450962C5.47782 0.379744 5.39298 0.323599 5.29959 0.285878C5.20621 0.248157 5.10618 0.229633 5.00547 0.231409C4.90477 0.233186 4.80546 0.255228 4.71346 0.29622C4.62146 0.337212 4.53866 0.396314 4.47 0.470001L0.469996 4.47C0.329546 4.61063 0.250656 4.80125 0.250656 5C0.250656 5.19875 0.329546 5.38938 0.469996 5.53L4.47 9.53C4.53866 9.60369 4.62146 9.66279 4.71346 9.70378C4.80546 9.74477 4.90477 9.76682 5.00547 9.76859C5.10618 9.77037 5.20621 9.75184 5.29959 9.71412C5.39298 9.6764 5.47782 9.62026 5.54903 9.54904C5.62025 9.47782 5.6764 9.39299 5.71412 9.2996C5.75184 9.20621 5.77036 9.10618 5.76859 9.00548C5.76681 8.90478 5.74477 8.80546 5.70378 8.71346C5.66279 8.62146 5.60368 8.53866 5.53 8.47L2.81 5.75H12.5C12.6989 5.75 12.8897 5.67098 13.0303 5.53033C13.171 5.38968 13.25 5.19891 13.25 5C13.25 4.80109 13.171 4.61032 13.0303 4.46967C12.8897 4.32902 12.6989 4.25 12.5 4.25H2.81L5.53 1.53Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a83510c8ff9cb3f489adaf1b0eaea97c.svg";
export { ForwardRef as ReactComponent };